module.exports = __webpack_public_path__ + "assets/img/1.784e89ea.png";